import React from 'react';
import PropTypes from 'prop-types';
import { Card, HeaderCard, TitleCard, ContentCard, Form, SelectLabel, CheckboxLabel, TooltipHelp, Button, Section } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Styles from '../resaleSettings.module.css';
import { getTemplateOptions } from '../utils';

function PrivateResale({ form, updateForm, loading, templates, loadingTemplates }) {
    const { t } = useTranslation();

    const templateOptions = React.useMemo(() => {
        return getTemplateOptions(templates, t);
    }, [templates]);

    const selectedTemplate = templates.find(t => t.id === form.share_link_template);

    const handlePreview = () => {
        if (selectedTemplate?.preview_url) {
            window.open(selectedTemplate.preview_url, '_blank');
        }
    };

    const handlePrivateResaleChange = checked => {
        updateForm('enable_private_resale', checked);

        // If enabling private resale, force share link to be enabled too
        if (checked) {
            updateForm('enabled_share_link', true);
        }
    };

    return (
        <Card>
            <HeaderCard>
                <TitleCard>{t('ticket.resales.settings.private_resale.title')}</TitleCard>
            </HeaderCard>
            <ContentCard>
                <Form>
                    <Form.Field>
                        <CheckboxLabel
                            checked={form.enable_private_resale}
                            onChange={(e, { checked }) => handlePrivateResaleChange(checked)}
                            label={
                                <>
                                    {t('ticket.resales.settings.private_resale.enable_private')}
                                    <TooltipHelp title={t('ticket.resales.settings.private_resale.enable_private_tooltip')} />
                                </>
                            }
                            disabled={loading}
                        />
                    </Form.Field>

                    <Form.Field>
                        <CheckboxLabel
                            checked={form.enable_private_resale ? true : form.enabled_share_link}
                            onChange={(e, { checked }) => updateForm('enabled_share_link', checked)}
                            label={
                                <>
                                    {t('ticket.resales.settings.private_resale.enable_share_link')}
                                    <TooltipHelp title={t('ticket.resales.settings.private_resale.enable_share_link_tooltip')} />
                                </>
                            }
                            disabled={loading || form.enable_private_resale}
                        />
                    </Form.Field>

                    {form.enabled_share_link && (
                        <Section className={Styles['private-resale-section']}>
                            <Form.Field>
                                <SelectLabel
                                    label={t('ticket.resales.settings.notifications.email_template')}
                                    placeholder={t('ticket.resales.settings.notifications.email_template_placeholder')}
                                    options={templateOptions}
                                    value={form.share_link_template}
                                    onChange={value => updateForm('share_link_template', value)}
                                    loading={loading || loadingTemplates}
                                    disabled={loading || loadingTemplates}
                                    clearable
                                />
                            </Form.Field>

                            <Button primary inverted label={t('ticket.resales.settings.notifications.preview')} onClick={handlePreview} disabled={!selectedTemplate?.preview_url} />
                        </Section>
                    )}
                </Form>
            </ContentCard>
        </Card>
    );
}

PrivateResale.propTypes = {
    form: PropTypes.object.isRequired,
    updateForm: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    templates: PropTypes.array.isRequired,
    loadingTemplates: PropTypes.bool
};

export default PrivateResale;
